import React, {ReactNode, useCallback} from "react";
import {Colors, Container, IconButton, IconEdit, Text} from "../../../../ui";
import {Link} from "../../../bounce-ui";

interface ContactDetailProps {
  type: string;
  title: ReactNode;
  value: string;
  isMissing?: boolean;
  onEditValue: (type: any, value: string) => void;
}

export const ContactDetail = ({type, title, value, onEditValue}: ContactDetailProps) => {
  const editHandler = useCallback(() => {
    onEditValue(type, value);
  }, [type, value, onEditValue]);

  return (
    <Container sx={{gap: "2px", alignItems: "start", mt: "6px"}}>
      <Text fontWeight={"bold"}>{title}</Text>
      {value ? (
        <Container row>
          <Text>{value}</Text>
          <IconButton size="small" onClick={editHandler}>
            <IconEdit color={Colors.primary._700} />
          </IconButton>
        </Container>
      ) : (
        <Link size={14} onClick={editHandler}>
          Add
        </Link>
      )}
    </Container>
  );
};
